import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import css from './Divider.css'

const HIDDEN_CLASSES = {
  sm: css['hidden-sm'],
  md: css['hidden-md'],
  lg: css['hidden-lg'],
  xl: css['hidden-xl'],
}

export const Divider = ({ hidden }) => {
  const classNames = classnames(
    css.divider,
    hidden.map(breakpoint => HIDDEN_CLASSES[breakpoint])
  )

  return (<hr className={classNames} />)
}

Divider.propTypes = {
  hidden: PropTypes.arrayOf(PropTypes.oneOf(['sm', 'md', 'lg', 'xl']))
}

Divider.defaultProps = {
  hidden: []
}
